import React, { useState, useEffect } from 'react' // Add useState, useEffect
import Header from './Header'
import { createClient } from '@supabase/supabase-js'; // Import createClient
import { supabaseUrl, supabaseKey } from '../config.ts'; // Import Supabase config
import Slider from "react-slick"; // Import Slider
import "slick-carousel/slick/slick.css"; // Import slick-carousel CSS
import "slick-carousel/slick/slick-theme.css"; // Import slick-carousel theme CSS

const supabase = createClient(supabaseUrl, supabaseKey); // Initialize Supabase client

const HomePage = () => {
  // State for testimonials
  const [feedback, setFeedback] = useState([]);
  const [loadingTestimonials, setLoadingTestimonials] = useState(true);
  const [testimonialError, setTestimonialError] = useState(null);

  useEffect(() => {
    const fetchTestimonials = async () => {
      setLoadingTestimonials(true);
      setTestimonialError(null); // Clear previous errors
      try {
        // Assuming 'feedback' table stores testimonials with 'feedbackText' and 'feedbackRating'
        const { data, error } = await supabase
        .from('feedback') // Assuming your table name is 'feedback'
        .select('*') // Select all columns, Supabase will map to the type
        .order('created_at', { ascending: false });

        if (error) {
          console.error('Error fetching testimonials:', error);
          throw new Error('Failed to load testimonials. Please try again.');
        }
        const formattedTestimonials = data.map(item => ({
          id: item.id,
          quote: item.comment || 'No feedback text provided.', // Updated to use 'comment'
          rating: item.rating ? parseInt(item.rating) : 0, // Updated to use 'rating' and parse to int
          author: 'Anonymous', // Default to Anonymous if no author field in feedback table
        }));

        setFeedback(formattedTestimonials);
      } catch (error) {
        console.error('Error fetching testimonials:', error.message);
        setTestimonialError(error.message);
        setFeedback([]);
      } finally {
        setLoadingTestimonials(false);
      }
    };

    fetchTestimonials();
  }, []); // Empty dependency array means this effect runs once on mount

  // Settings for react-slick carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Show 3 testimonials at a time on large screens
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true, // Explicitly enable navigation arrows
    responsive: [
      {
        breakpoint: 1024, // For screens smaller than 1024px
        settings: {
          slidesToShow: 2, // Show 2 testimonials
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: true // Ensure arrows are enabled for this breakpoint too
        }
      },
      {
        breakpoint: 768, // For screens smaller than 768px (md breakpoint)
        settings: {
          slidesToShow: 1, // Show 1 testimonial
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: true // Ensure arrows are enabled for this breakpoint too
        }
      },
      {
        breakpoint: 480, // For screens smaller than 480px
        settings: {
          slidesToShow: 1, // Show 1 testimonial
          slidesToScroll: 1,
          arrows: true // Ensure arrows are enabled for this breakpoint too
        }
      }
    ]
  };

  return (
    <>
      <div className="hero-header overflow-hidden position-relative">
        {/* Background Elements */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background:
              "linear-gradient(135deg, rgba(247,247,255,0.1) 0%, rgba(247,247,255,0.4) 100%)"
          }}
        />
        <div className="rotate-img position-absolute">
          <img src="../../assets/img/sty-1.png" className="img-fluid opacity-25" alt="" />
          <div className="rotate-sty-2 animate-float" />
        </div>
        {/* Main Content */}
        <div className="container py-5">
          <div className="row gy-5 align-items-center">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
              <div className="pe-lg-5">
                <h1
                  className="display-4 fw-bold text-dark mb-4 wow fadeInUp"
                  data-wow-delay="0.3s"
                >
                  Building Dreams,{" "}
                  <span className="text-primary">Crafting Reality</span>
                </h1>
                <p
                  className="fs-5 mb-5 text-muted wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  Transform your ideas into reality with our innovative construction
                  and project management solutions. We deliver excellence, on time
                  and within budget.
                </p>

              </div>
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.2s">
              <div className="position-relative">
                <div
                  className="bg-primary rounded-4 position-absolute"
                  style={{
                    width: "100%",
                    height: "100%",
                    top: "-20px",
                    right: "-20px",
                    zIndex: 0,
                    opacity: "0.1"
                  }}
                />
                <img
                  src="../../assets/img/hero-img-1.png"
                  className="img-fluid w-100 rounded-4 shadow-lg position-relative hover-float"
                  alt="Hero Image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hero Header End */}
      {/* Navbar & Hero End */}
      {/* About Start */}
      {/* <div
        className="container-fluid overflow-hidden py-5"
        style={{
          marginTop: "6rem",
          background:
            'linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url("../../assets/img/bg-pattern.png")'
        }}
      >
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="position-relative overflow-hidden rounded-4 shadow-lg">
                <img
                  src="../../assets/img/about-1.png"
                  className="img-fluid w-100 transform-hover"
                  alt=""
                />

              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="ps-lg-5">
                <div className="border-start border-5 border-primary ps-4 mb-4">
                  <h6 className="text-body text-uppercase mb-2">About Us</h6>
                  <h1 className="display-6 mb-0">
                    Start Your Journey with a Personalized Project Tour
                  </h1>
                </div>
                <p className="mb-4 text-muted">
                  Take the first step toward realizing your vision with a guided
                  project tour, personalized just for you. Explore cutting-edge
                  tools, efficient workflows, and proven techniques that ensure
                  quality and reliability at every stage.
                </p>
                <div className="bg-light p-4 rounded-3 mb-4">
                  <h5 className="text-primary">Your Project, Our Priority</h5>
                  <p className="mb-0">
                    With a customized tour, see firsthand how we turn ideas into
                    reality. From groundbreaking designs to flawless execution,
                    we're here to bring your dreams to life with precision and care.
                  </p>
                </div>
                <div className="bg-light p-4 rounded-3 mb-4">
                  <h5 className="text-primary">See What's Possible</h5>
                  <p className="mb-0">
                    Join us for a personalized tour that highlights innovative
                    solutions, expert craftsmanship, and unmatched commitment to
                    excellence. Let us show you how we can make your project a
                    success, every step of the way.
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  <a
                    href="/about"
                    className="btn btn-primary rounded-pill py-3 px-5"
                  >
                    Learn More
                  </a>
                  <a
                    href="/contact"
                    className="btn btn-outline-primary rounded-pill py-3 px-5 ms-3"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* About End */}
      {/* Service Start */}
      <div
        className="container-fluid service py-5"
        style={{
          background:
            'linear-gradient(rgba(255,255,255,0.95), rgba(255,255,255,0.95)), url("../../assets/img/bg-pattern.png")'
        }}
      >
        <div className="container py-5">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: 900 }}
          >
            <span className="text-primary text-uppercase fw-bold">
              Our Services
            </span>
            <h1 className="display-5 mb-4 mt-2">What We Can Do For You</h1>
            <p className="lead text-muted mb-0">
              We specialize in turning your construction dreams into reality. From
              initial planning to project completion, our team provides
              comprehensive solutions tailored to your needs.
            </p>
          </div>
          <div className="row g-4 justify-content-center">
            <div
              className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
              data-wow-delay="0.1s"
            >
              {/* <a href="/service" className="text-decoration-none text-dark"> */}
                <div className="service-item text-center rounded-4 shadow-sm p-4 hover-translate-y">
                  {/* Replaced image with icon for modern UI */}
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto mb-4 rounded-circle bg-primary"
                    style={{ width: '80px', height: '80px', fontSize: '36px', color: '#fff' }}
                  >
                    <i className="fas fa-hard-hat"></i>
                  </div>
                  <div className="service-content">
                    <h5 className="fw-bold mb-4">Pre-Construction Services</h5>
                  </div>
                </div>
              {/* </a> */}
            </div>
            <div
              className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              {/* <a href="/service" className="text-decoration-none text-dark"> */}
                <div className="service-item text-center rounded-4 shadow-sm p-4 hover-translate-y">
                  {/* Replaced image with icon for modern UI */}
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto mb-4 rounded-circle bg-primary"
                    style={{ width: '80px', height: '80px', fontSize: '36px', color: '#fff' }}
                  >
                    <i className="fas fa-building"></i>
                  </div>
                  <div className="service-content">
                    <h5 className="fw-bold mb-4">General Construction Services</h5>
                  </div>
                </div>
              {/* </a> */}
            </div>
            <div
              className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              {/* <a href="/service" className="text-decoration-none text-dark"> */}
                <div className="service-item text-center rounded-4 shadow-sm p-4 hover-translate-y">
                  {/* Replaced image with icon for modern UI */}
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto mb-4 rounded-circle bg-primary"
                    style={{ width: '80px', height: '80px', fontSize: '36px', color: '#fff' }}
                  >
                    <i className="fas fa-paint-roller"></i>
                  </div>
                  <div className="service-content">
                    <h5 className="fw-bold mb-4">Renovation and Remodeling</h5>
                  </div>
                </div>
              {/* </a> */}
            </div>
            <div
              className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
              data-wow-delay="0.7s"
            >
              {/* <a href="/service" className="text-decoration-none text-dark"> */}
                <div className="service-item text-center rounded-4 shadow-sm p-4 hover-translate-y">
                  {/* Replaced image with icon for modern UI */}
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto mb-4 rounded-circle bg-primary"
                    style={{ width: '80px', height: '80px', fontSize: '36px', color: '#fff' }}
                  >
                    <i className="fas fa-road"></i>
                  </div>
                  <div className="service-content">
                    <h5 className="fw-bold mb-4">Civil Construction Services</h5>
                  </div>
                </div>
              {/* </a> */}
            </div>
            <div
              className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
              data-wow-delay="0.3s"
            >
              {/* <a href="/service" className="text-decoration-none text-dark"> */}
                <div className="service-item text-center rounded-4 shadow-sm p-4 hover-translate-y">
                  {/* Replaced image with icon for modern UI */}
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto mb-4 rounded-circle bg-primary"
                    style={{ width: '80px', height: '80px', fontSize: '36px', color: '#fff' }}
                  >
                    <i className="fas fa-tasks"></i>
                  </div>
                  <div className="service-content">
                    <h5 className="fw-bold mb-4">Project Management</h5>
                  </div>
                </div>
              {/* </a> */}
            </div>
            <div
              className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              {/* <a href="/service" className="text-decoration-none text-dark"> */}
                <div className="service-item text-center rounded-4 shadow-sm p-4 hover-translate-y">
                  {/* Replaced image with icon for modern UI */}
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto mb-4 rounded-circle bg-primary"
                    style={{ width: '80px', height: '80px', fontSize: '36px', color: '#fff' }}
                  >
                    <i className="fas fa-leaf"></i>
                  </div>
                  <div className="service-content">
                    <h5 className="fw-bold mb-4">
                      Sustainable and Green Construction
                    </h5>
                  </div>
                </div>
              {/* </a> */}
            </div>
          </div>
        </div>
      </div>
      {/* Service End */}
      {/* Feature Start */}
      <div
        className="container-fluid feature overflow-hidden py-5"
        style={{ background: "#f6f6fa" }}
      >
        <div className="container py-5">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: 900 }}
          >
            <h4 className="text-primary">Our Feature</h4>
            <h1 className="display-5 mb-4">
              Discover the standout features of our construction services, designed
              to ensure quality, efficiency, and customer satisfaction
            </h1>
            <p className="mb-0">
              We deliver exceptional construction services with expert
              craftsmanship, innovative solutions, and tailored designs.
              Prioritizing safety, sustainability, and on-time delivery, we ensure
              your project exceeds expectations with clear communication and modern
              techniques.
            </p>
          </div>
        </div>
      </div>
      <div className="container-fluid feature overflow-hidden py-5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s">
              <div className="feature-img position-relative">
                <div
                  className="bg-primary rounded-4 position-absolute"
                  style={{
                    width: "100%",
                    height: "100%",
                    top: "-15px",
                    left: "-15px",
                    zIndex: 0,
                    opacity: "0.1"
                  }}
                />
                <img
                  src="../../assets/img/features-1.png"
                  className="img-fluid w-100 rounded-4 shadow-lg position-relative hover-float"
                  alt="Feature Image"
                />

              </div>
            </div>
            <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.1s">
              <div className="ps-lg-5">
                <div className="border-start border-5 border-primary ps-4 mb-4">
                  <h6 className="text-primary text-uppercase mb-2">
                    Our Achievement
                  </h6>
                  <h1 className="display-5 mb-0">
                    Transforming Visitors Into Delighted Customers
                  </h1>
                </div>
                <p className="mb-4 lead text-muted">
                  We excel in creating exceptional experiences that convert visitors
                  into loyal customers. Our innovative solutions and dedicated
                  approach ensure lasting impressions and remarkable results.
                </p>
                <div className="row g-4 mb-4">
                  <div className="col-sm-6">
                    <div className="bg-light rounded-4 p-4 hover-scale">
                      <div className="d-flex align-items-center mb-2">
                        <div className="btn btn-primary rounded-circle p-3 me-3">
                          <i className="fas fa-newspaper" />
                        </div>
                        <h2 className="mb-0 counter">100+</h2>
                      </div>
                      <p className="mb-0 text-muted">Successful Projects</p>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="bg-light rounded-4 p-4 hover-scale">
                      <div className="d-flex align-items-center mb-2">
                        <div className="btn btn-primary rounded-circle p-3 me-3">
                          <i className="fas fa-users" />
                        </div>
                        <h2 className="mb-0 counter">500+</h2>
                      </div>
                      <p className="mb-0 text-muted">Satisfied Clients</p>
                    </div>
                  </div>
                </div>
                <div className="d-flex gap-3">
                  <a
                    href="/contact"
                    className="btn btn-primary rounded-pill py-3 px-5 shadow-sm hover-scale"
                  >
                    Get Started
                    <i className="fas fa-arrow-right ms-2" />
                  </a>
                  <a
                    href="/Services"
                    className="btn btn-outline-primary rounded-pill py-3 px-5 hover-scale"
                  >
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonial Start */}
      <div className="container-fluid py-5 testimonial">
        <div className="container py-5">
          <div
            className="text-center mx-auto mb-5 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ maxWidth: 900 }}
          >
            <h4 className="text-primary">Our Testimonials</h4>
            <h1 className="display-5 mb-4">What Our Clients Say About Us</h1>
            <p className="mb-0">
              Hear directly from our satisfied clients about their experiences working with us.
              Their success stories are our greatest reward.
            </p>
          </div>
          <div className="row g-4 justify-content-center"> {/* Keep row for initial layout, but Slider will manage items */}
            {loadingTestimonials ? (
              <div className="col-12 text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading testimonials...</p>
              </div>
            ) : testimonialError ? (
              <div className="col-12 text-center">
                <div className="alert alert-danger" role="alert">
                  {testimonialError}
                </div>
              </div>
            ) : feedback.length > 0 ? (
              <div className="col-12"> {/* Wrap slider in a col-12 */}
                <Slider {...settings}>
                  {feedback.map((testimonial) => (
                    <div key={testimonial.id} className="p-2"> {/* Add padding for spacing between slides */}
                      <div className="testimonial-item rounded-4 shadow-sm p-4 bg-light">
                        <div className="d-flex align-items-center mb-3">
                          <i className="fa fa-quote-left fa-2x text-primary me-3"></i>
                          <div>
                            {/* <h5 className="mb-1">{testimonial.author}</h5> */}
                            <div className="text-warning">
                              {[...Array(5)].map((_, i) => (
                                <i key={i} className={`fa-star ${i < testimonial.rating ? 'fas' : 'far'}`}></i>
                              ))}
                            </div>
                          </div>
                        </div>
                        <p className="mb-0 text-muted">"{testimonial.quote}"</p>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            ) : (
              <div className="col-12 text-center">
                <p>No testimonials found yet.</p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Testimonial End */}
    </>

  )
}

export default HomePage